<nav>
  <div class="navigation-sidebar pt-2">
    <ul class="nav flex-column">
      <li class="nav-item w-100">
        <a class="nav-link"
          routerLink="/search"
          [class.active]="startsWithUrl('/search')"
        >
          <fa-icon class="pr-2" icon="search"></fa-icon>
          <span i18n="@@header.search">Search</span>
        </a>
        <a class="nav-link"
          routerLink="/vehicles"
          [class.active]="startsWithUrl('/vehicles')"
        >
          <fa-icon class="pr-2" icon="car"></fa-icon>
          <span i18n="@@header.vehicles">Vehicles</span>
        </a>
        <ul class="nav flex-column pl-3">
          <li *ngIf="vehiclesService.vehicle">
            <span class="nav-link active" [ngSwitch]="startsWithUrl('/vehicles/' + vehiclesService.vehicle.vin + '/')">
              <fa-icon class="pr-2" icon="caret-right" *ngSwitchCase="false"></fa-icon>
              <fa-icon class="pr-2" icon="caret-down" *ngSwitchCase="true"></fa-icon>
              <span>{{vehiclesService.vehicle.nickname || vehiclesService.vehicle.vin}}</span>
            </span>
            <ul class="nav flex-column pl-3">
              <li>
                <span class="nav-link active"
                  *ngIf="startsWithUrl('/vehicle-trips/' + vehiclesService.vehicle.vin)"
                >
                  <fa-icon class="pr-2" icon="caret-right"></fa-icon>
                  <span i18n="@@vehicles.trips.title">Trips</span>
                </span>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item w-100">
        <a class="nav-link"
          routerLink="/vehicle-trips"
          [class.active]="isCurrentUrl('/vehicle-trips')"
        >
          <fa-icon class="pr-2" icon="road"></fa-icon>
          <span i18n="@@header.trips">Trips</span>
        </a>
      </li>
      <li *ngIf="isSuperAdmin$" class="nav-item w-100">
        <a class="nav-link"
          routerLink="/odometers"
          [class.active]="startsWithUrl('/odometers')"
        >
          <fa-icon class="pr-2" icon="tachometer-alt"></fa-icon>
          <span i18n="@@header.odometers">Odometers</span>
        </a>
        <ul class="nav flex-column pl-3">
          <li class="w-100" *ngIf="odometersService.odometer">
            <span class="nav-link active">
              <fa-icon class="pr-2" icon="caret-down"></fa-icon>
              <span>{{odometersService.odometer.value}}</span>
            </span>
          </li>
        </ul>
      </li>
      <li *ngIf="isSuperAdmin$" class="nav-item w-100">
        <a class="nav-link"
          routerLink="/programs"
          [class.active]="startsWithUrl('/programs')"
        >
          <fa-icon class="pr-2" icon="cog"></fa-icon>
          <span i18n="@@header.programs">Programs</span>
        </a>
        <ul class="nav flex-column pl-3">
          <li class="w-100" *ngIf="programsService.program">
            <span class="nav-link active">
              <fa-icon class="pr-2" icon="caret-down"></fa-icon>
              <span>{{programsService.program.title || programsService.program.key}}</span>
            </span>
          </li>
        </ul>
      </li>
      <li *ngIf="isSuperAdmin$" class="nav-item w-100">
        <a class="nav-link"
          routerLink="/pricings"
          [class.active]="isCurrentUrl('/pricings')"
        >
          <fa-icon class="pr-2" icon="dollar-sign"></fa-icon>
          <span i18n="@@header.pricings">Pricing Scheme</span>
        </a>
      </li>
      <li class="nav-item w-100">
        <a class="nav-link"
          routerLink="/incentives"
          [class.active]="isCurrentUrl('/incentives')"
        >
          <fa-icon class="pr-2" icon="grin-stars"></fa-icon>
          <span i18n="@@header.incentives">Incentive Scheme</span>
        </a>
      </li>
      <li class="nav-item w-100">
        <a class="nav-link"
          routerLink="/charges"
          [class.active]="startsWithUrl('/charges')"
        >
          <fa-icon class="pr-2" icon="coins"></fa-icon>
          <span i18n="@@header.charges">Charges</span>
        </a>
      </li>
      <li class="nav-item w-100">
        <a class="nav-link"
          routerLink="/transactions"
          [class.active]="startsWithUrl('/transactions')"
        >
          <fa-icon class="pr-2" icon="credit-card"></fa-icon>
          <span i18n="@@header.transactions">Transactions</span>
        </a>
      </li>
      <li class="nav-item w-100">
        <a class="nav-link"
          routerLink="/users"
          [class.active]="startsWithUrl('/users')"
        >
          <fa-icon class="pr-2" icon="users"></fa-icon>
          <span i18n="@@header.users">Users</span>
        </a>
        <ul class="nav flex-column pl-3">
          <li class="w-100" *ngIf="usersService.user">
            <span *ngIf="startsWithUrl('/users')" class="nav-link active text-truncate">
              <fa-icon class="pr-2" icon="caret-down"></fa-icon>
              <span>{{usersService.user.email}}</span>
            </span>
          </li>
        </ul>
      </li>
      <li *ngIf="isSuperAdmin$" class="nav-item w-100">
        <a class="nav-link"
           routerLink="/subscriptions"
           [class.active]="startsWithUrl('/subscriptions')"
        >

          <fa-icon class="pr-2" icon="cog"></fa-icon>
          <span i18n="@@header.subscriptions">Subscriptions</span>
        </a>
      </li>
      <li *ngIf="isSuperAdmin$" class="nav-item w-100">
        <a class="nav-link"
           routerLink="/network-configs"
           [class.active]="startsWithUrl('/network-configs')"
        >
          <fa-icon class="pr-2" icon="cog"></fa-icon>

          <span i18n="@@header.network-configs">Network Configs</span>
        </a>
      </li>
      <li class="nav-item w-100">
        <a class="nav-link"
           routerLink="/devices"
           [class.active]="startsWithUrl('/devices')"
        >
          <fa-icon class="pr-2" icon="cog"></fa-icon>

          <span i18n="@@header.devices">Devices</span>
        </a>
      </li>
      <li *ngIf="isSuperAdmin$" class="nav-item w-100">
        <a class="nav-link"
           routerLink="/notification"
           [class.active]="startsWithUrl('/notification')"
        >
          <fa-icon class="pr-2" icon="cog"></fa-icon>

          <span i18n="@@header.notification">Notifications</span>
        </a>
      </li>
<!--      <li class="nav-item w-100">-->
<!--        <a class="nav-link"-->
<!--           routerLink="/requests"-->
<!--           [class.active]="startsWithUrl('/requests')"-->
<!--        >-->
<!--          <span i18n="@@header.requests">Requests</span>-->
<!--        </a>-->
<!--      </li>-->
    </ul>
  </div>

  <div class="user-sidebar position-absolute w-100">
    <ul class="nav flex-column">
      <li class="nav-item bg-secondary w-100">
        <a class="nav-link text-white text-truncate pl-1"
          pointer (click)="userShow = !userShow"
        >
          <span class="px-2 v-align">
            <fa-icon icon="caret-down" [hidden]="!userShow"></fa-icon>
            <fa-icon icon="caret-right" [hidden]="userShow"></fa-icon>
          </span>
          <span>{{user?.name || user?.email}}</span>
        </a>
        <ul class="nav flex-column" [hidden]="!userShow">
          <li>
            <a class="nav-link pl-3"
              pointer (click)="logout()"
            >
              <fa-icon class="pr-2" icon="sign-out-alt"></fa-icon>
              <span i18n="@@header.signout">Log out</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>
